'use strict';
const timeUtils = require('../util/time');


const REDUCED_MAX_BANDWIDTH_KBPS = 750;

module.exports = (function () {
    return {
        getStartPosition: function (videoElement) {
            return Number(videoElement.getAttribute('data-video-startposition')) || 0;
        },
        setStartPosition: function (videoElement, startPosition) {
            videoElement.setAttribute('data-video-startposition', startPosition);
        },
        getSplashText: function (videoElement) {
            let text;
            if (videoElement.getAttribute('data-video-splash-text')) {
                text = videoElement.getAttribute('data-video-splash-text');
            } else if (videoElement.getAttribute('data-video-length')) {
                text = String(timeUtils.getFormattedVideoLength(Number(videoElement.getAttribute('data-video-length'))));
            }

            return text;
        },
        getUID: function (videoElement) {
            return videoElement.getAttribute('data-video-uid');
        },
        generateAndSetUID: function (videoElement) {
            const uid = String(Math.round(Math.random() * 1000000));
            videoElement.setAttribute('data-video-uid', uid);

            return uid;
        },
        getMaxBitrate: function (videoElement) {
            return videoElement.getAttribute('data-video-reduced-bandwidth') === 'true' ? REDUCED_MAX_BANDWIDTH_KBPS : undefined;
        },
        isControlsEnabled: function (videoElement) {
            return videoElement.hasAttribute('data-video-controls');
        },
        getImmersiveFormat: function (videoElement) {
            return videoElement.getAttribute('data-video-immersive-format');
        },
        isAutoplayOfNextVideo: function (videoElement) {
            return videoElement.hasAttribute('data-autoplay-of-next-video');
        }
    };
})();



// WEBPACK FOOTER //
// ./src/js/util/video-attributes.js